export enum CustomClients {
  Standard = 'standard',
  Allianz = 'allianz',
  Arval = 'arval',
  Vorwerk = 'vorwerk',
  VKB = 'vkb',
  LufthansaMediacenter = 'lufthansa-mediacenter',
  LufthansaMedialounge = 'lufthansa-medialounge',
  WestLotto = 'westlotto',
  SEAT = 'seat',
}

export enum CustomClientsTitle {
  Standard = 'MakeOS',
  Allianz = 'Allianz',
  Arval = 'Arval',
  Vorwerk = 'Vorwerk',
  VKB = 'VKB',
  LufthansaMediacenter = 'Lufthansa Mediacenter',
  LufthansaMedialounge = 'Lufthansa Medialounge',
  WestLotto = 'WestLotto',
  SEAT = 'SEAT',
}

export interface NavigationConfig {
  imprintUrl?: string;
  privacyUrl?: string;
  supportUrl?: string;
  termsUrl?: string;
  contactUrl?: string;
}

export interface BrandConfig {
  sidebarImage?: string;
  loginLogo?: string;
  mainLogo?: string;
  secondaryLogo?: string;
  sidebarLogo?: string;
  mottoText?: string;
  color?: {
    main: string;
    background: string;
  };
  navigation?: NavigationConfig;
}

/**
 * The logo in the top left corner of the app.
 *
 * @param brand
 * @returns
 */
export function brandedLogoUrl(brand?: CustomClients) {
  if (brand === CustomClients.Allianz) {
    return `https://cdn.serviceplanmakeos.com/assets/logos/${brand.toLowerCase()}/brand-logo.svg`;
  }
  if (brand === CustomClients.SEAT) {
    return 'assets/logos/brand-logo.png';
  }
  // default Serviceplan logo
  return 'assets/logos/brand-logo.svg';
}

/**
 * The logo shown on the login page. Usually a bit larger, with e.g. logo and text.
 *
 * @param brand
 * @returns
 */
export function brandedLoginLogoUrl(brand?: CustomClients) {
  if (brand && brand !== CustomClients.Standard && brand !== CustomClients.WestLotto) {
    return `https://cdn.serviceplanmakeos.com/assets/logos/${brand.toLowerCase()}/login-logo.svg`;
  }
  // default Serviceplan MAKEOS logo
  return 'assets/logos/login-logo.png';
}

/**
 * Image to display on the sidebar, e.g. login page. Not all brands have an image here.
 *
 * @param brand
 * @returns
 */
export function brandedSidebarImageUrl(brand?: CustomClients) {
  let url;
  if (brand?.toLowerCase() === 'unicredit') {
    url = `https://cdn.serviceplanmakeos.com/assets/logos/${brand.toLowerCase()}/sidebar.png`;
  }
  return url;
}

/**
 * The logo, loaded in emails. It must be a png or jpg.
 *
 * @param brand
 * @returns
 */
export function brandedEmailLogoUrl(brand?: CustomClients) {
  if (brand) {
    return `https://cdn.serviceplanmakeos.com/assets/logos/${brand.toLowerCase()}/email-logo.png`;
  }
  // default Serviceplan MAKEOS logo
  return 'https://cdn.serviceplanmakeos.com/assets/logos/email-logo.png';
}

export function brandedConfig(brand?: CustomClients): BrandConfig {
  const defaultConfig: BrandConfig = {
    color: {
      main: '#000',
      background: '#000',
    },
  };

  if (brand) {
    // not sure where to place this mapping
    if (brand === CustomClients.Allianz) {
      return {
        color: {
          main: '#013781',
          background: '#013781',
        },
      };
    }
  }

  return defaultConfig;
}
